(function () {
  // Only run if enabled via theme settings
  if (!window.solisAnimations) return;
  if (!window.solisAnimations.fadeUp) return;
 
  // Load Motion from CDN then init
  var script = document.createElement('script');
  script.src = 'https://cdn.jsdelivr.net/npm/motion@latest/dist/motion.js';
  script.onload = function () {
    initFadeUp();
  };
  document.head.appendChild(script);
 
  function initFadeUp() {
    var Motion = window.Motion;
    if (!Motion) return;
 
    var inView = Motion.inView;
    var animate = Motion.animate;
 
    // Elements to animate
    var selectors = [
      '.shopify-section',
      '.product-card',
      '.collection-card',
      '.blog-card',
      '.resource-card',
    ].join(', ');
 
    var elements = document.querySelectorAll(selectors);
 
    elements.forEach(function (el, i) {
      // Set initial state
      el.style.opacity = '0';
      el.style.transform = 'translateY(40px)';
      el.style.willChange = 'opacity, transform';
 
      inView(
        el,
        function () {
          animate(
            el,
            { opacity: 1, y: 0 },
            {
              duration: 0.7,
              ease: [0.22, 0.03, 0.26, 1],
              delay: 0.05,
            }
          );
          // Return cleanup to prevent re-animating
          return function () {};
        },
        { amount: 0.15 }
      );
    });
  }
})();